import { render, staticRenderFns } from "./classifiedGoods.vue?vue&type=template&id=608a410e&scoped=true"
import script from "./classifiedGoods.vue?vue&type=script&lang=ts"
export * from "./classifiedGoods.vue?vue&type=script&lang=ts"
import style0 from "./classifiedGoods.vue?vue&type=style&index=0&id=608a410e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608a410e",
  null
  
)

export default component.exports